import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import * as _ from 'lodash';
import { AccountService } from '../services/account/account.service';
import { AppointmentService } from '../services/appointment/appointment.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

interface ResponseObject {
  readonly data: any;
  readonly errorCode: number;
  readonly message: boolean;
  readonly status: string;
}

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css']
})

export class AppointmentsComponent implements OnInit {

  modalRef: BsModalRef;

  customDateFormat = "";
  calendarOptions: NgxDrpOptions;
  selectedDateRange: Range = { fromDate: new Date(), toDate: new Date() };
  presets: Array<PresetItem> = [];
  dateRangeView: string;

  accounts = [];
  accountId = null;


  dropdownSettings: any = {};

  screeningCenterList = [];
  selectedScreeningCenters = [];
  orgIds = [];
  showScreeningCenterDropdown = false;

  operators = [];
  selectedOperator = [];
  operatorIds = [];
  showOperatorDropdown = false;

  screeningCenterToBind = null;
  operatorToBind = null;

  appointments = [];

  showAppointmentDetails = false;
  showRescheduleTemplate = false;
  isChecked = false;
  isSelectAll = false;
  cancelAppointmentCount: any;
  selectedAppointment: any

  totalAppointmentsCount = 0;
  page = 1;

  selectedTab = "scheduledAppointments"
  showCustomNotificationTemplate = false;

  @ViewChild('dateRangePicker', { static: true }) dateRangePickerView;

  customNotificationDropdown: { id: number; name: any; }[];
  searchByPatientMRN: any;
  mrnInputText: any;

  constructor(
    public foruscareService: ForuscareService,
    public accountService: AccountService,
    public appointmentService: AppointmentService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getAccounts();
    this.customDateFormat = this.foruscareService.getDateFormat().split(" ")[0];
    const today = new Date();
    const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const fromMin = new Date();
    fromMin.setMonth(today.getMonth() - 1);
    const fromMax = new Date();
    const toMin = new Date();
    toMin.setFullYear(today.getFullYear() - 1);
    const toMax = new Date();

    this.setupPresets();
    this.calendarOptions = {
      presets: this.presets,
      //format: 'mediumDate',
      format: this.foruscareService.getDateFormat().split(" ")[0],
      range: {
        fromDate: startDate,
        toDate: today
      },
      fromMinMax: {
        fromDate: today,
        toDate: null
      },
      toMinMax: {
        fromDate: today,
        toDate: null
      },
      applyLabel: 'Submit',
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: true,
        hasBackdrop: true
      }
    };
    this.selectedDateRange = {
      fromDate: startDate,
      toDate: today
    };
    this.dateRangeView = this.getDateRangeString(this.selectedDateRange);

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
  }

  getDateRangeString(daterange: Range): string {
    const fromDateString: string[] = daterange.fromDate.toDateString().split(' ');
    const toDateString: string[] = daterange.toDate.toDateString().split(' ');

    return `${fromDateString[1]} ${fromDateString[2]}, ${fromDateString[3]} - ${toDateString[1]} ${toDateString[2]}, ${toDateString[3]}`;
  }

  setupPresets() {
    const nextDate = (numOfDays: number) => {
      const currentDate = new Date();
      return new Date(currentDate.setDate(currentDate.getDate() + numOfDays));
    };

    const today = new Date();
    const tomorrow = nextDate(1);
    const plus7 = nextDate(7);
    const plus30 = nextDate(30);
    let currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    currMonthStart < today ? currMonthStart = today : currMonthStart;

    this.presets = [
      { presetLabel: 'Tomorrow', range: { fromDate: tomorrow, toDate: tomorrow } },
      { presetLabel: 'Next 7 Days', range: { fromDate: today, toDate: plus7 } },
      { presetLabel: 'Next 30 Days', range: { fromDate: today, toDate: plus30 } },
      { presetLabel: 'This Month', range: { fromDate: currMonthStart, toDate: currMonthEnd } }
    ];
  }

  // handler function that receives the updated date range object
  updateDateRange(updatedRange: Range): void {
    if (_.isEqual(this.selectedDateRange, updatedRange)) {
      return;
    }

    const selectedFromYear = updatedRange.fromDate.getFullYear();
    const selectedToYear = updatedRange.toDate.getFullYear();
    const selectedFromMonth = updatedRange.fromDate.getMonth();
    const selectedToMonth = updatedRange.toDate.getMonth();
    const selectedFromDate = updatedRange.fromDate.getDate();
    const selectedToDate = updatedRange.toDate.getDate();
    let isDateSwitched = false;

    if (selectedToYear < selectedFromYear) {
      isDateSwitched = true;
      // this.foruscareService.showNotification("alert", "danger");
    }

    if (selectedToYear === selectedFromYear && selectedToMonth < selectedFromMonth) {
      isDateSwitched = true;
      // this.foruscareService.showNotification("alert", "danger");
    }

    if ((selectedToYear > selectedFromYear || selectedToYear === selectedFromYear) && selectedFromMonth === selectedToMonth && selectedToDate < selectedFromDate) {
      isDateSwitched = true;
      // this.foruscareService.showNotification("alert", "danger");
    }

    this.selectedDateRange = updatedRange;
    this.dateRangeView = this.getDateRangeString(this.selectedDateRange);

    if (isDateSwitched) {
      const from = updatedRange.fromDate;
      const to = updatedRange.toDate;
      updatedRange = {
        fromDate: to,
        toDate: from
      };

      this.dateRangePickerView.resetDates(updatedRange);
    } else {

    }
  }

  getAccounts(): void {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe((response: ResponseObject) => {
        if (response.errorCode === 200 && response.status === this.foruscareService.RESULT_SUCCESS) {
          if (response.data !== null) {
            this.accounts = response.data.sort((a: any, b: any) => this.sortAlphaNumeric(a, b, 'accountName'));
          }
        } else {
          this.foruscareService.showNotification(response.message, 'danger');
        }
      });
  }

  sortAlphaNumeric(a: any, b: any, propertyName: string) {
    if (a[propertyName] && b[propertyName]) {
      let A = a[propertyName];
      let B = b[propertyName];

      // convert to strings and force lowercase
      A = (typeof A === 'string') ? A.toLowerCase() : A.toString();
      B = (typeof b === 'string') ? B.toLowerCase() : B.toString();

      return A.localeCompare(B);
    } else {
      return 0;
    }
  }

  getScreeningCentersByAccountID(): void {
    this.showScreeningCenterDropdown = false;
    this.showOperatorDropdown = false;
    this.screeningCenterToBind = null;
    this.operatorToBind = null;
    this.screeningCenterList = [];
    this.selectedScreeningCenters = [];
    this.operatorIds = [];
    if (this.accountId !== null && this.accountId > 0) {
      this.accountService.screeningCentersByAccount(this.accountId)
        .subscribe((response: ResponseObject) => {
          if (response.errorCode == 200 && response.data && response.data.length > 0) {
            response.data.forEach(element => {
              this.screeningCenterList.push({ id: element.orgId, itemName: element.orgName });
            });
            this.showScreeningCenterDropdown = true;
          } else {
            this.foruscareService.showNotification("Screening Centers Unavailable", 'danger');
          }
          // this.screeningCenterList = response.data.sort((a: any, b: any) => this.sortAlphaNumeric(a, b, 'orgName'));
        });
    }
  }

  onSelectScreeningCenter(obj, action) {
    this.operatorToBind = null;
    this.orgIds = [];
    this.operatorIds = [];
    this.operators = [];
    this.showOperatorDropdown = false;
    switch (action) {
      case "ADD":
        this.selectedScreeningCenters.push(obj);
        break;
      case "REMOVE":
        for (var i = 0; i < this.selectedScreeningCenters.length; i++) {
          if (obj.id == this.selectedScreeningCenters[i].id) {
            this.selectedScreeningCenters.splice(i, 1);
            break;
          }
        }
        break;
      case "ADD_ALL":
        this.selectedScreeningCenters = obj;
        break;
      case "REMOVE_ALL":
        this.selectedScreeningCenters.splice(0);
        break;
    }
    if (this.selectedScreeningCenters == null || this.selectedScreeningCenters.length == 0) {
      this.foruscareService.showNotification("Please select screening center", "danger");
      return;
    }
    this.selectedScreeningCenters.forEach(element => {
      this.orgIds.push(parseInt(element.id));
    });
    this.getOperator();
  }

  getOperator(): void {
    this.cancelAppointmentCount = 0;
    if (this.orgIds !== null || this.orgIds.length > 0) {
      this.appointmentService.getOperatorListByAccountAndScreeningCenter(this.orgIds)
        .subscribe((response) => {
          if (response.errorCode == 200 && response.data && response.data.length > 0) {
            console.log(response, "operator list");
            response.data.forEach(element => {
              this.operators.push({ id: element.userId, itemName: element.firstName });
            });
            this.showOperatorDropdown = true;
          } else {
            this.foruscareService.showNotification("No Operators available", 'danger');
          }
        });
    }
  }

  onSelectOperator(obj, action) {
    this.operatorIds = [];
    switch (action) {
      case "ADD":
        this.selectedOperator.push(obj);
        break;
      case "REMOVE":
        for (var i = 0; i < this.selectedOperator.length; i++) {
          if (obj.id == this.selectedOperator[i].id) {
            this.selectedOperator.splice(i, 1);
            break;
          }
        }
        break;
      case "ADD_ALL":
        this.selectedOperator = obj;
        break;
      case "REMOVE_ALL":
        this.selectedOperator.splice(0);
        break;
    }
    this.selectedOperator.forEach(element => {
      this.operatorIds.push(parseInt(element.id));
    });
  }

  getAppointmentDetails(offset: any, action: any) {

    if (action == 'start') {
      this.mrnInputText = null;
      this.searchByPatientMRN = null;
    }

    let payload = {
      accountId: this.accountId,
      orgIds: this.orgIds,
      operatorIds: this.operatorIds,
      startDate: this.selectedDateRange.fromDate.getFullYear() + '-' + (this.selectedDateRange.fromDate.getMonth() < 10 ? "0" + (this.selectedDateRange.fromDate.getMonth() + 1) : (this.selectedDateRange.fromDate.getMonth() + 1)) + '-' + (this.selectedDateRange.fromDate.getDate() < 10 ? "0" + (this.selectedDateRange.fromDate.getDate()) : (this.selectedDateRange.fromDate.getDate())),
      endDate: this.selectedDateRange.toDate.getFullYear() + '-' + (this.selectedDateRange.toDate.getMonth() < 10 ? "0" + (this.selectedDateRange.toDate.getMonth() + 1) : (this.selectedDateRange.toDate.getMonth() + 1)) + '-' + (this.selectedDateRange.toDate.getDate() < 10 ? "0" + (this.selectedDateRange.toDate.getDate()) : (this.selectedDateRange.toDate.getDate())),
      offset: offset,
      count: 10,
      patientMrn: this.searchByPatientMRN
    }

    this.appointmentService.getAppointmentsDataByFilter(payload).subscribe((response => {
      if (response.data !== null && response.data.totalCount > 0) {
        this.appointments = response.data.response;
        this.totalAppointmentsCount = response.data.totalCount;
        this.appointments.forEach(object => {
          object.isChecked = false;
        });
        this.checkForAllAppointmentSelect(action);
      } else {
        this.appointments = null;
        this.cancelAppointmentCount = 0;
        this.payloadData = [];
        this.isChecked = false;
        this.isSelectAll = false;
      }
    }));

    this.showAppointmentDetails = true;
    offset == 0 ? this.page = 1 : null;
  }

  checkForAllAppointmentSelect(action) {
    if (this.isSelectAll && action == 'newPage') {
      this.appointments.forEach(object => {
        object.isChecked = true;
      });
      this.isChecked = true;
      this.cancelAppointmentCount = this.totalAppointmentsCount;
    } else {
      this.cancelAppointmentCount = 0;
      this.payloadData = [];
      this.isChecked = false;
      this.isSelectAll = false;
    }
  }

  payloadData = [];

  checkedValue(data) {
    this.isSelectAll = false;
    this.isChecked = false;
    let selectedItem = {
      patientId: data.patientId,
      mrn: data.mrn,
      appointmentId: data.appointmentId
    }
    if (this.payloadData.length == 0) {
      this.payloadData.push(selectedItem);
      this.cancelAppointmentCount = this.payloadData.length;
      if (this.cancelAppointmentCount == this.totalAppointmentsCount) {
        this.isChecked = true
      }
      return;
    }

    for (let i = 0; i < this.payloadData.length; i++) {
      if (selectedItem.appointmentId == this.payloadData[i].appointmentId) {
        this.payloadData.splice(this.payloadData.indexOf(this.payloadData[i]), 1);
        this.cancelAppointmentCount = this.payloadData.length;
        return;
      }
    }
    this.payloadData.push(selectedItem);
    if (this.payloadData.length === this.appointments.length) {
      this.isChecked = true;
    }
    this.cancelAppointmentCount = this.payloadData.length;
  }

  CheckAllOptions() {
    if (this.appointments.every(val => val.isChecked == true)) {
      this.appointments.forEach(val => { val.isChecked = false });
      this.payloadData = [];
    }
    else {
      this.appointments.forEach(val => { val.isChecked = true });
      this.payloadData = [];
      for (let i = 0; i < this.appointments.length; i++) {
        let allItems = {
          patientId: this.appointments[i].patientId,
          mrn: this.appointments[i].mrn,
          appointmentId: this.appointments[i].appointmentId
        }
        this.payloadData.push(allItems);
      }
    }
    this.cancelAppointmentCount = this.payloadData.length;
  }

  CheckAllPagesOptions() {
    if (this.isSelectAll) {
      this.isChecked = true;
      this.appointments.forEach(val => { val.isChecked = true });
      this.payloadData = [];
      this.cancelAppointmentCount = this.totalAppointmentsCount;
    } else {
      this.isChecked = false;
      this.appointments.forEach(val => { val.isChecked = false });
      this.cancelAppointmentCount = 0;
    }
  }

  cancelAppointmentModal(longContent: TemplateRef<any>) {
    if (this.payloadData.length == 0 && this.isSelectAll == false) {
      this.foruscareService.showNotification("Please select atleast one appointment", 'danger');
    } else if (this.isSelectAll) {
      this.cancelAppointmentCount = this.totalAppointmentsCount;
      this.modalRef = this.modalService.show(longContent);
    } else {
      this.cancelAppointmentCount = this.payloadData.length;
      this.modalRef = this.modalService.show(longContent);
    }
  }

  cancelAppointment() {
    let cancelAppointmentByPatientId = [];
    if (this.payloadData.length !== 0) {
      for (let i = 0; i < this.payloadData.length; i++) {
        cancelAppointmentByPatientId.push(parseInt(this.payloadData[i].appointmentId));
      }
    }
    let payload = {
      startDate: this.selectedDateRange.fromDate.getFullYear() + '-' + (this.selectedDateRange.fromDate.getMonth() < 10 ? "0" + (this.selectedDateRange.fromDate.getMonth() + 1) : (this.selectedDateRange.fromDate.getMonth() + 1)) + '-' + (this.selectedDateRange.fromDate.getDate() < 10 ? "0" + (this.selectedDateRange.fromDate.getDate()) : (this.selectedDateRange.fromDate.getDate())),
      endDate: this.selectedDateRange.toDate.getFullYear() + '-' + (this.selectedDateRange.toDate.getMonth() < 10 ? "0" + (this.selectedDateRange.toDate.getMonth() + 1) : (this.selectedDateRange.toDate.getMonth() + 1)) + '-' + (this.selectedDateRange.toDate.getDate() < 10 ? "0" + (this.selectedDateRange.toDate.getDate()) : (this.selectedDateRange.toDate.getDate())),
      accountId: this.accountId,
      appointmentIds: cancelAppointmentByPatientId,
      orgIds: this.orgIds,
      operatorIds: this.operatorIds
    }

    this.appointmentService.cancelAppointmentsById(payload)
      .subscribe((response: any) => {
        if (response.errorCode == 200 && response.status == "Success") {
          this.getAppointmentDetails(0, 'cancel');
          this.foruscareService.showNotification("Appointment(s) cancelled successfully", 'success');
          this.cancelAppointmentCount = 0;
          this.payloadData = [];
          this.isChecked = false;
          this.isSelectAll = false;
        } else {
          this.foruscareService.showNotification("Something went wrong! please try again", 'danger');
        }
      });
  }

  onRescheduleClick(data: any) {
    this.selectedAppointment = data;
    this.showRescheduleTemplate = true;
  }

  onBackClick() {
    this.showRescheduleTemplate = false;
  }

  onrescheduleCancel(event: any) {
    this.showRescheduleTemplate = false;
    console.log(event)
  }

  onRescheduleCompleted(event: any) {
    console.log(event);
    this.calendarOptions.range = {
      fromDate: this.selectedDateRange.fromDate,
      toDate: this.selectedDateRange.toDate
    }
    this.showRescheduleTemplate = false;
    this.getAppointmentDetails(0, 'reschedule');
  }

  onTableDataChange(pageNumber) {
    this.cancelAppointmentCount = 0;
    this.page = pageNumber;
    this.getAppointmentDetails((pageNumber - 1) * 10, 'newPage');
    this.isChecked = false;
  }

  updateSelectedTab(action: any) {
    if (action == 'Scheduled Appointments') {
      this.resetInitialTab();
      this.selectedTab = "scheduledAppointments";
      this.showCustomNotificationTemplate = false;
      if (this.operatorIds.length > 0) {
        this.calendarOptions.range = {
          fromDate: this.selectedDateRange.fromDate,
          toDate: this.selectedDateRange.toDate
        }
        this.getAppointmentDetails(0, 'tab');
      }
    } else if (action == 'Custom Notifications') {
      this.selectedTab = "customNotifications";
      this.showCustomNotificationTemplate = true;
    }
  }

  resetInitialTab() {
    this.accountId = null;
    this.screeningCenterToBind = null;
    this.operatorToBind = null;
    this.appointments = [];
    this.showOperatorDropdown = false;
    this.showScreeningCenterDropdown = false;
    this.showAppointmentDetails = false;
    const today = new Date();
    const updatedRange: Range = {
      fromDate: today,
      toDate: today
    };
    if(this.dateRangePickerView)
    this.dateRangePickerView.resetDates(updatedRange);
  }

  searchByMRN(input: any) {
    this.searchByPatientMRN = input;
    this.getAppointmentDetails(0, 'mrn');
  }

}
